/**
 * Component for FocusTraits
 * Component used to render the FocusTraits
 *
 * @module components
 */

import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

import { ContentSections } from '../../constants/ContentSections';
import QA from '../../constants/QATags';
import { renderParagraph } from '../../lib/ArrayUtils';
import { withVisibilityLogger } from '../VisibilityLogger/VisibilityLogger';

import './FocusTraits.scss';

export const MAX_NUM_FOCUS_TRAITS = 5;

export class FocusTraits extends React.Component {
  static propTypes = {
    focusTraits: PropTypes.instanceOf(List),
  };

  renderFocusTraits = focusTraitsSize => {
    const focusTraitsFull = this.props.focusTraits;
    const focusTraitsSnippet = focusTraitsFull.setSize(
      Math.min(MAX_NUM_FOCUS_TRAITS, focusTraitsSize),
    );
    return renderParagraph(focusTraitsSnippet);
  };

  render() {
    const focusTraitsSize = this.props.focusTraits.size;
    return (
      <div className='FocusTraits' key='FocusTraits' data-qa={QA.FT}>
        <div className='FocusTraits__content'>
          <div className='FocusTraits__content__innerWrapper'>
            {this.renderFocusTraits(focusTraitsSize)}
          </div>
        </div>
      </div>
    );
  }
}

export const FocusTraitsWithLogger = withVisibilityLogger({
  contentSections: ContentSections.SONG_FEATURES,
})(FocusTraits);

export default FocusTraits;
